// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"041c2c76","182":"99a8364f","259":"1ce9d62e","312":"7d5b62d2","551":"bc2aaa37","629":"e6ec2ed3","833":"2a00effc","842":"761af9d0"}[chunkId] + ".chunk.js";
};